
import { Options, Vue } from 'vue-class-component'
import Sekretariatet from '@/components/Frontend/Sekretariatet/index.vue'

@Options({
  components: {
    Sekretariatet
  }
})
export default class SekretariatetView extends Vue {}
